/**
 * @class
 * @extends mkE.Base
 */
D.Inspector = Class(
	/**
	 * @lends {D.Inspector#}
	 */
	{
		_popups: 0,
		__construct: function(par) {
			this.par = par;
			this.node = mkE({
				tag: 'div',
				id: 'insp',
				className: 'expanded',
				els: [
					{
						tag: 'a',
						className: 'insp__toggle',
						onclick: () => {
							this.closePopup();
							toggleClassName(this.node, 'expanded');
						}
					},
					this.menu = mkE({
						tag: 'div',
						className: 'insp__menu',
						els: [
							new D.Inspector.Block.Lang(this),
							new D.Inspector.Block.Meta(this)
						]
					})
				]
			});
		},

		popup(title, els, onClose = null) {
			this.closePopup();
			this._popup = mkE({
				tag: 'div',
				className: 'insp__popup',
				els: [
					{
						tag: 'div',
						className: 'insp__popup__title',
						els: [
							title,
							{
								tag: 'a',
								className: 'close',
								onclick: this.closePopup,
								els: [
									D.svgIcon('close')
								]
							}
						]
					},
					this._popupContent = mkE({
						tag: 'div',
						className: 'insp__popup__content',
						els: [
							els
						]
					})
				]
			}).prepend(this.node);
			this._popupOnClose = onClose;
			return ++this._popups;
		},

		popupUpdate(els) {
			clearNode(this._popupContent);
			mkE.appendTypeElement(this._popupContent, els);
			return this;
		},

		isPopupOpen(idx = null) {
			if (idx !== null && idx !== this._popups) {
				return false;
			}
			return !!this._popup;
		},

		closePopup() {
			if (this._popup) {
				this._popup.remove();
				delete this._popup;
				if (this._popupOnClose) {
					this._popupOnClose();
					this._popupOnClose = null;
				}
			}
			return this;
		}
	},
	mkE.Base
);

/**
 * @class
 * @param {D.Inspector} par
 * @extends mkE.Base
 */
D.Inspector.Block = Class(
	/**
	 * @lends {D.Inspector.Block#}
	 */
	{
		/** @type {D.Inspector} */
		inspector: null,
		_popup: 0,
		/** @param {D.Inspector} inspector */
		__construct: function(inspector) {
			this.inspector = inspector;
			this.node = mkE({
				tag: 'div',
				className: 'd-flex'
			});
			this.draw();
		},
		/** @abstract */
		draw() {
		},
		/**
		 * @param {String} title
		 * @param els
		 * @param {Function} onClose
		 */
		popup(title, els, onClose = null) {
			this._popup = this.inspector.popup(title, els, onClose);
		},
		popupUpdate(els) {
			this.inspector.popupUpdate(els);
		},
		/** @return boolean */
		popupToggle() {
			if (this.isPopupOpen()) {
				this.inspector.closePopup();
				return false;
			}
			return true;
		},
		isPopupOpen() {
			return this.inspector.isPopupOpen(this._popup);
		}
	},
	mkE.Base
);

/**
 * @class
 * @extends D.Inspector.Block
 */
D.Inspector.Block.Lang = Class(
	/**
	 * @lends {D.Inspector.Lang#}
	 */
	{
		_lokaliseEnabled: false,
		_pendingChange: true,
		_keys: {
			missing: [],
			used: [],
			total: 0
		},
		draw() {
			this._lokaliseEnabled = Boolean(sessionStorage.getItem('insp-lokalise'));
			this._keys.total = count(D.Language[D.LANG]);
			mkE.appendTypeElement(this.node, [
				this._keysTotalNode = mkE({
					tag: 'span',
					title: 'Total language keys',
					els: [
						{
							tag: 'span',
							text: '🌍 '
						},
						this._keys.total
					]
				}),
				this._keysUsedNode = mkE({
					tag: 'span',
					title: 'Used language keys',
					text: '0000'
				}),
				this._missingKeysNode = mkE({
					tag: 'a',
					title: 'Untranslated language keys',
					onclick: this.show,
					text: '0'
				}),
				{
					tag: 'label',
					els: [
						'Lokalise ',
						{
							tag: 'input',
							type: 'checkbox',
							onchange: (e) => {
								if (e.target.checked) {
									sessionStorage.setItem('insp-lokalise', '1');
								} else {
									sessionStorage.removeItem('insp-lokalise');
								}
								window.location.reload();
							},
							checked: this._lokaliseEnabled
						}
					]
				}
			]);
			D.Lang._get = D.Lang.get;
			D.Lang.get = this.get;
			this.lokalise();
			this._tick();
		},
		get(string, placeholder, lang = null) {
			if (!D.Lang.exists(string)) {
				if (this._keys.missing.indexOf(string) === -1) {
					this._keys.missing.push(string);
				}
			} else if (this._keys.used.indexOf(string) === -1) {
				this._keys.used.push(string);
			}
			let re = D.Lang._get(string, placeholder);
			if (this._lokaliseEnabled && string.search('url') === -1) {
				re = `#L#${string}#${re}`;
			}
			this._pendingChange = true;
			return re;
		},
		lokalise() {
			if (this._lokaliseEnabled) {
				window.LOKALISE_CONFIG = {
					projectId: this.inspector.par.lokalise,
					locale: D.LANG,
					disableAdvancedHtml: true
				};
				let a = document.createElement('script');
				a.type = 'text/javascript';
				a.async = !0;
				a.src = ['https://app.lokalise.com/live-js/script.min.js?', (new Date).getTime()].join('');
				document.body.appendChild(a);
			}
		},
		show() {
			if (!this.popupToggle()) {
				return;
			}
			this.popup('Missing translations', []);
			this.drawPopup();
		},
		drawPopup() {
			if (!this.isPopupOpen()) {
				return;
			}
			this.popupUpdate([
				{
					tag: 'div',
					els: [
						{
							tag: 'ul',
							els: (() => {
								let re = [];
								for (let i = 0; i < this._keys.missing.length; i++) {
									const missingLocalisation = this._keys.missing[i];
									re.push({
										tag: 'li',
										text: missingLocalisation
									});
								}
								return re;
							})()
						}
					]
				}
			]);
		},
		_tick() {
			if (this._pendingChange) {
				this._pendingChange = false;
				if (this._lokaliseEnabled) {
					this._updateLokalise();
				}
				this._keysUsedNode.innerText = this._keys.used.length;
				if (this._keys.missing.length) {
					addClassName(this._missingKeysNode, 'text-danger');
					this._missingKeysNode.innerText = `🚩 ${this._keys.missing.length}`;
				} else {
					removeClassName(this._missingKeysNode, 'text-danger');
					this._missingKeysNode.innerText = `0`;
				}
				this.drawPopup();
			}
			setTimeout(this._tick, 1000);
		},
		_updateLokalise() {
			const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT);
			let node;
			while (node = walker.nextNode()) {
				if (node.nodeValue.search('#L#') === 0) {
					const match = node.nodeValue.match(/#L#(.*?)#/);
					if (match[1]) {
						node.parentNode.setAttribute('data-lokalise', '');
						node.parentNode.setAttribute('data-key', match[1]);
						node.nodeValue = node.nodeValue.substr(match[0].length);
					}
				}
			}
			document.dispatchEvent(new Event('lokalise-update-elements'));
		}
	},
	D.Inspector.Block
);

/**
 * @class
 * @extends D.Inspector.Block
 */
D.Inspector.Block.Meta = Class(
	/**
	 * @lends {D.Inspector.Meta#}
	 */
	{
		draw() {
			mkE.appendTypeElement(this.node, [
				{
					tag: 'a',
					text: 'META',
					onclick: this.show
				}
			]);
		},
		show() {
			if (!this.popupToggle()) {
				return;
			}
			document.addEventListener('SectionReady', this.drawPopup);
			this.popup('Meta', [], () => {
				document.removeEventListener('SectionReady', this.drawPopup);
			});
			this.drawPopup();
		},
		drawPopup() {
			let prefix = D.SITE_B2B ? 'b2b.' : '';
			const tags = [
				{'t': 'robots', 's': 'meta[name="robots"]', 'p': ['content']},
				{'t': 'title', 's': 'title', 'p': null},
				{'t': 'description', 's': 'meta[name="description"]', 'p': ['content']},
				{'t': 'og:title', 's': 'meta[property="og:title"]', 'p': ['content'], 'lang': prefix + 'web.og.{key}.title'},
				{'t': 'og:description', 's': 'meta[property="og:description"]', 'p': ['content'], 'lang': prefix + 'web.og.{key}.description'},
				{'t': 'og:image', 's': 'meta[property="og:image"]', 'p': ['content']},
				{'t': 'canonical', 's': 'link[rel="canonical"]', 'p': ['href']},
				{'t': 'alternate', 's': 'link[rel="alternate"]', 'p': ['href', 'hreflang']}
			];
			const url = new Url();
			url.shift();
			const section = url.current || 'home';
			this.popupUpdate([
				{
					tag: 'table',
					className: 'table table-striped mb-4',
					style: {
						'word-break': 'break-word'
					},
					els: (() => {
						let re = [
							{
								tag: 'tr',
								els: [
									{
										tag: 'th',
										text: 'Tag'
									},
									{
										tag: 'th',
										text: 'Value'
									},
									{
										tag: 'th',
										text: 'Lokalise key'
									}
								]
							}];

						for (let i = 0; i < tags.length; i++) {
							const tag = tags[i];
							const els = document.head.querySelectorAll(tag.s);
							const values = [];
							for (let j = 0; j < els.length; j++) {
								const el = els[j];
								let properties = [];
								if (tag.p) {
									for (let k = 0; k < tag.p.length; k++) {
										const p = tag.p[k];
										properties.push(el.getAttribute(p));
									}
								} else {
									properties.push(el.innerText);
								}
								values.push(properties.join(', '));
							}
							re.push({
								tag: 'tr',
								els: [
									{
										tag: 'td',
										text: tag.t
									},
									{
										tag: 'td',
										els: [
											{
												tag: 'ul',
												els: (() => {
													let re = [];
													for (let j = 0; j < values.length; j++) {
														const value = values[j];
														let color = '';
														let title = '';
														if((tag.t === 'title' && value.length > 61) || (tag.t === 'description' && value.length > 158)) {
															color ='text-danger';
															title = 'Too long';
														}
														re.push({
															tag: 'li',
															className: color,
															text: value,
															title: title
														});
													}
													return re;
												})()
											}
										]
									},
									{
										tag: 'td',
										text: tag.lang ? tag.lang.replace('{key}', section) : ''
									}
								]
							});
						}
						return re;
					})()
				}
			]);
		}
	},
	D.Inspector.Block
);

